module.exports = __webpack_public_path__ + "img/a4.40ef92c1.jpg";